import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";

declare var ko: any;

export class goalsList_template extends vnTemplate{

    public pagination: pagination_template;
    public brandsFilter: filterDropdown_template;
    public initiativesFilter: filterDropdown_template;
    public monthsFilter: filterDropdown_template;
    public groupsFilter: filterDropdown_template;
    public resultsInfo: resultsInfo_template;
    public validationsList: validationsList_template;


    protected getTemplateHtml(): string{

        return `

                <div class="sub-header">
                    <div class="w-justify">
                        <div class="w-left">
                            <div><label class="form-label" for="" >Brands</label> ${ this.brandsFilter.getHtmlBuild() }</div>
                            <div><label class="form-label" for="" >Initiatives</label> ${ this.initiativesFilter.getHtmlBuild() } </div>
                            <div><label class="form-label" for="" >Net Category group</label> ${ this.groupsFilter.getHtmlBuild() }</div>
                            <div><label class="form-label" for="" >Months</label> ${ this.monthsFilter.getHtmlBuild() }</div>
                        </div>
                    </div>
                </div>
                <div class="list-header margin-top w-justify">
                    <div class="w-left">
                        <button data-bind="click: onClickAdd" class="btn secondary icon i-add" type="button">Add Goal</button>
                    </div>
                    <div class="w-right">
                        ${ this.pagination.getHtmlBuild() }
                    </div>
                </div>
                
         
                <div class="w-list-results"  id="list-results">
                    <table class="list-results">
                        ${ this.resultsInfo.getHtmlBuild() }
                        <thead>
                            <input data-bind="value: orderBy" type="hidden">
                            <input data-bind="value: orderByDirection" type="hidden">
                            <tr>
                                <th><span>Edit</span></th>
                                <th><span data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }" class="icon list-sort-none">Id</span></th>
                                <th><span data-bind="event: { click: onClickReorder.bind($data, 'idBrand') }, css: { 'list-sort-desc': orderByAndDirection()=='idBrand_DESC', 'list-sort-asc': orderByAndDirection()=='idBrand_ASC' }" class="icon list-sort-none">Brand</span></th>
                                <th><span data-bind="event: { click: onClickReorder.bind($data, 'initiative') }, css: { 'list-sort-desc': orderByAndDirection()=='initiative_DESC', 'list-sort-asc': orderByAndDirection()=='initiative_ASC' }" class="icon list-sort-none">Initiative</span></th>
                                <th><span data-bind="event: { click: onClickReorder.bind($data, 'group') }, css: { 'list-sort-desc': orderByAndDirection()=='group_DESC', 'list-sort-asc': orderByAndDirection()=='group_ASC' }" class="icon list-sort-none">Network Group</span></th>
                                <th><span data-bind="event: { click: onClickReorder.bind($data, 'year') }, css: { 'list-sort-desc': orderByAndDirection()=='year_DESC', 'list-sort-asc': orderByAndDirection()=='year_ASC' }" class="icon list-sort-none">Year</span></th>
                                <th><span data-bind="event: { click: onClickReorder.bind($data, 'month') }, css: { 'list-sort-desc': orderByAndDirection()=='month_DESC', 'list-sort-asc': orderByAndDirection()=='month_ASC' }" class="icon list-sort-none">Month</span></th>
                                <th><span data-bind="event: { click: onClickReorder.bind($data, 'articleCount') }, css: { 'list-sort-desc': orderByAndDirection()=='articleCount_DESC', 'list-sort-asc': orderByAndDirection()=='articleCount_ASC' }" class="icon list-sort-none">Articles Count</span></th>
                                <th><span data-bind="event: { click: onClickReorder.bind($data, 'sessionsPerArticle') }, css: { 'list-sort-desc': orderByAndDirection()=='sessionsPerArticle_DESC', 'list-sort-asc': orderByAndDirection()=='sessionsPerArticle_ASC' }" class="icon list-sort-none">Sessions Per Article</span></th>
                                <th><span data-bind="event: { click: onClickReorder.bind($data, 'costPerArticle') }, css: { 'list-sort-desc': orderByAndDirection()=='costPerArticle_DESC', 'list-sort-asc': orderByAndDirection()=='costPerArticle_ASC' }" class="icon list-sort-none">Cost Per Article</span></th>
                                <th><span data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }" class="icon list-sort-none">Creation Date</span></th>
                                <th><span data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }" class="icon list-sort-none">Update Date</span></th>
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: goals">        
                            <tr>
                                <td class="align-left"><button class="btn icon border only-icon icon i-view" type="button" data-bind="click: $parent.onClickEdit"></button></td>
                                <td class="goal_id"><span data-bind="text: id"></span></td>
                                <td class="goal_brand"><span data-bind="text: brand.name"></span></td>
                                <td class="goal_initiative"><span data-bind="text: initiative.name"></span></td>
                                <td class="goal_group"><span data-bind="text: group.name"></span></td>
                                <td class="goal_year"><span data-bind="text: year"></span></td>
                                <td class="goal_month"><span data-bind="text: displayMonth"></span></td>
                                <td class="goal_articleCount"><span data-bind="text: articleCount"></span></td>
                                <td class="goal_sessionsPerArticle"><span data-bind="text: sessionsPerArticle"></span></td>
                                <td class="goal_costPerArticle"><span data-bind="text: costPerArticle"></span></td>
                                <td class="goal_dateCreated"><span data-bind="text: dateCreated"></span></td>
                                <td class="goal_dateUpdated"><span data-bind="text: dateUpdated"></span></td>
                            </tr>                 
                        <tbody>
                        <tfoot>
                        </tfoot>
                    </table>
                </div>
            `;
    }

    protected initPartial(): void {

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.brandsFilter = new filterDropdown_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.initiativesFilter = new filterDropdown_template("initiativesFilter", this.getTemplateViewModel(), this.caller);
        this.groupsFilter = new filterDropdown_template("groupsFilter", this.getTemplateViewModel(), this.caller);
        this.monthsFilter = new filterDropdown_template("monthsFilter", this.getTemplateViewModel(), this.caller);
        this.resultsInfo = new resultsInfo_template("resultsInfo", this.getTemplateViewModel(), this.caller);
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string{

        return "goalsList_template";
    }

    protected getMainElementType(): string{

        return "div";
    }

    protected getMainElementClasses(): Array<string>{

    	return ["w-content"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let self = this;
        return  {
            orderBy: ko.observable("initiative"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("initiative_ASC"),
            goals: ko.observableArray([]),
            isLoading: ko.observable(false),
            onClickReorder : function(value, data, event){ self.onClickReorder(value, data, event); },
            onClickAdd: function (data, event) { self.onClickAdd(); },
            onClickEdit: function (data, event) {
                self.onClickEdit(data.id);
            },
        };
    }

    //
    // implementation of base class [vnTemplate]
    public getViewModelForRequest(){

        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            filter: {
                brand: this.viewModel.goals.brandsFilter.selectedOption,
                initiative: this.viewModel.goals.initiativesFilter.selectedOption,
                group: this.viewModel.goals.groupsFilter.selectedOption,
                month: this.viewModel.goals.monthsFilter.selectedOption
            }
        }
    }

    public onClickReorder(value, data, event){

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)){
            if( data.orderByDirection() == "DESC" ){
                data.orderByDirection("ASC");
            }
            else{
                data.orderByDirection("DESC");
            }
        }
        else{
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.goalsListReorder();
    }
    /**
     *
     * @param id
     */
    public onClickView(id): void {
        this.caller.viewGoal(id);
    }

    /**
     *
     * @param id
     */
    public onClickEdit(id): void {
        this.caller.editGoal(id);
    }



    public onClickAdd(): void {
        this.caller.addGoal();
    }

    public setGoals(goals): void{

        this.getTemplateViewModel().goals(goals);
    }

    public setBrandsFilterItems(brands:  Array<{id: number,  name: string}>): void {

        brands.unshift({id:0, name: 'all'});
        this.brandsFilter.setOptions(brands);
    }

    public setInitiativesFilterItems(initiatives: Array<{id: number, initiative: string, name: string}>): void {

        initiatives.unshift({id:0, name: 'all', initiative: 'all'});
        this.initiativesFilter.setOptions(initiatives);
    }

    public setGroupsFilterItems(groups: Array<{id: number,  name: string}>): void {

        groups.unshift({id:0, name: 'all'});
        this.groupsFilter.setOptions(groups);
    }

    public setMonthsFilterItems(months: Array<{id: number,  name: string}>): void {

        months.unshift({id:0, name: 'all'});
        this.monthsFilter.setOptions(months);
    }

    /**
     *
     * @param nbResults
     * @param nbPages
     * @param execTime
     */
    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultsInfo.setExecutionTime(execTime);
        this.resultsInfo.setNbResults(nbResults);
        this.resultsInfo.setNbPages(nbPages);
    }

    public setPaginationTotalCount(totalCount: number):  void {
        this.pagination.setNumberItemToPaginate(totalCount);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/goalsList_template.ts